import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getOrganizationChartResources = async (
  projectId,
  activeEmployerInfo
) => {
  const apiPath = `organization-charts/project/${projectId}/organization-chart-resources`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
